import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  UserOutline,
  BellOutline,
  LineChartOutline
} from '@ant-design/icons-angular/icons';

export const icons = [
  MenuFoldOutline, 
  MenuUnfoldOutline, 
  DashboardOutline, 
  FormOutline, 
  UserOutline,
  BellOutline,
  LineChartOutline
];
